module.exports = __webpack_public_path__ + "hair-model-a3ccc5.webp";